export default __webpack_public_path__ + "static/mecca-no-quote-5fb8020ba7dcd66dfe8c17560156fc91.png";